module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Hummer2-e107f6ad22afd0edbc705165524f1e2f.svg";